import React from "react";
import { Container } from "react-bootstrap";

import "../../../css/ISI.scss";

export default function ISIITP() {
  return (
    <div className="isi-wrapper">
      <div className="expansion_content text-left">
        <Container>
          <section className="mb-1">
            <p className="text-blue"><strong>What are DOPTELET (avatrombopag) and DOPTELET Sprinkle (avatrombopag)?</strong></p>
            <p className="mb-0">DOPTELET is a prescription medicine used to treat low blood platelet counts in:</p>
            <ul className="mb-2">
              <li>Adults with long-lasting (chronic) liver disease (CLD) who are scheduled to have a medical or dental procedure</li>
              <li>Adults with chronic immune thrombocytopenia (ITP) when other treatments have not worked well enough.</li>
              <li>Children 1 year and older with persistent or chronic ITP when other treatments have not worked well enough</li>
            </ul>
          </section>
        </Container>
      </div>
    </div>
  );
}
